/* eslint-disable camelcase */
import React, { Component } from 'react';
import {
  Button,
  Form,
  Dropdown,
  TextArea,
  Divider,
  Loader,
  Grid
} from 'semantic-ui-react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import { getTagsForCategories } from '../../services/TagService';

import {
  insertDashboard,
  updateDashboard,
  insertDashboardTags,
  updateDashboardTag
} from '../../services/DashboardService';

import * as AppActions from '../../actions';
import './ManageDashboard.css';

class ManageDashboard extends Component {
  state = {
    errorMessage: '',
    message: '',
    models: [],
    selectedModels: '',
    processing: false,
    tagsByCategoryOptions: [],
    chosenTagsByCategory: [],
    form: {
      name: '',
      alias: '',
      dashboardId: '',
      internalDesc: '',
      externalDesc: '',
      access_filter: '',
      model: [],
      id: ''
    }
  };

  componentDidMount() {
    this.fillModels();
    const { dashboardToEdit, dashboardsTagsToEdit } = this.props;
    if (dashboardToEdit) {
      this.initializeEdit(this.props.dashboardToEdit);
    }

    if (dashboardsTagsToEdit && dashboardToEdit) {
      this.initializeDashboardsTagsEdit(this.props.dashboardsTagsToEdit);
    }

    const tagCategories = ['dashboard_type', 'funding'];
    this.setTagOptionValuesByCategory(tagCategories);
  }

  initializeEdit = async (dashboardToEdit) => {
    const form = this.state.form;
    form.name = dashboardToEdit.name;
    form.alias = dashboardToEdit.alias;
    form.dashboardId = dashboardToEdit.dashboard_id;
    form.internalDesc = dashboardToEdit.internal_desc;
    form.externalDesc = dashboardToEdit.external_desc;
    form.access_filter = dashboardToEdit.access_filter;
    form.id = dashboardToEdit.id;

    if (dashboardToEdit.model) {
      dashboardToEdit.model.split(',').map((item) => {
        form.model.push(item);
        return null;
      });
    }
    this.setState({ form, selectedModels: dashboardToEdit.model.split(',') });
  };

  initializeDashboardsTagsEdit = async (dashboardsTagsToEdit) => {
    const chosenTagsByCategory = this.state.chosenTagsByCategory;

    try {
      dashboardsTagsToEdit.forEach((row) => {
        const selectionToInsert = {
          category: row.tag.category,
          tag: row.tag_id
        };
        chosenTagsByCategory.push(selectionToInsert);
      });
      this.setState({ chosenTagsByCategory });
    } catch (error) {
      console.log(error);
    }
  };

  goBackSearch = () => {
    const prevForm = this.state.form;
    prevForm.id = '';
    this.setState({ form: prevForm });
    this.props.searchPage();
  };

  fillModels = () => {
    const modelsOptions = [
      { key: 0, value: 'facebook_ads', text: 'Facebook Ads' },
      { key: 1, value: 'google_adwords', text: 'Google Adwords' },
      { key: 2, value: 'google_analytics', text: 'Google Analytics' },
      { key: 3, value: 'facebook_product_catalog', text: 'Facebook Product Catalog' },
      { key: 4, value: 'facebook_spend', text: 'Facebook Spend' },
      { key: 5, value: 'google_sheets', text: 'Google Sheets' },
      { key: 6, value: 'spend_reports', text: 'Spend Reports' },
      { key: 7, value: 'ecommerce', text: 'E-Commerce' },
      { key: 8, value: 'vin_data', text: 'VIN Data' },
      { key: 9, value: 'lacarguy', text: 'LA Car Guy' },
      { key: 10, value: 'shopify', text: 'Shopify' },
      { key: 11, value: 'biohaven', text: 'Biohaven' },
      { key: 12, value: 'Alexia_Reporting', text: 'Alexia Reporting' }
    ];
    this.setState({ models: modelsOptions });
  };

  cleanData = () => {
    this.setState({
      chosenTagsByCategory: [],
      form: {
        name: '',
        alias: '',
        dashboardId: '',
        internalDesc: '',
        externalDesc: '',
        model: [],
        access_filter: '',
        id: ''
      },
      selectedModels: ''
    });
  };

  handleFormChange = (event, { name, value }) => {
    this.setState({ form: { ...this.state.form, [name]: value } });
  };

  onModelSelect = (e, data) => {
    const models = [];

    data.value.map((val) => {
      const model = _.find(data.options, (option) => {
        return option.value === val;
      });

      if (model) {
        models.push(model.value);
      }
      return null;
    });

    const form = this.state.form;
    form.model = models;

    this.setState({ form, selectedModels: data.value });
  };

  saveDashboard = async () => {
    const {
      name,
      alias,
      dashboardId,
      internalDesc,
      externalDesc,
      model,
      access_filter,
      id
    } = this.state.form;
    const { chosenTagsByCategory } = this.state;
    const { dashboardToEdit, dashboardsTagsToEdit } = this.props;

    this.setState({ errorMessage: '', message: '', processing: true });

    if (!name || !dashboardId || !access_filter || model.length === 0) {
      this.setState({
        errorMessage: 'The id, name, access_filter and models are required',
        processing: false
      });
      return;
    }

    const modelValues = model.join(',');

    const dashboardData = {
      dashboard_id: parseInt(dashboardId, 0),
      name,
      model: modelValues,
      alias,
      access_filter,
      internal_desc: internalDesc,
      external_desc: externalDesc
    };

    if (dashboardToEdit) {
      dashboardData.id = dashboardToEdit.id;
    }

    const result = !dashboardToEdit
      ? await insertDashboard(dashboardData)
      : await updateDashboard(dashboardData);

    if (!dashboardsTagsToEdit) {
      await insertDashboardTags(result.id, chosenTagsByCategory);
    }

    if (dashboardsTagsToEdit || dashboardToEdit) {
      await updateDashboardTag(id, chosenTagsByCategory);
    }

    if (result.statusCode === 200) {
      const message = !dashboardToEdit
        ? 'The Dashboard has been created'
        : 'The Dashboard has been updated';

      if (!dashboardToEdit) {
        this.cleanData();
      }

      this.setState({ message, processing: false });
      this.goBackSearch();
    } else {
      this.setState({
        errorMessage: 'There was an error saving the dashboard',
        processing: false
      });
    }
  };

  onAccessFilterSelect = async (event, data) => {
    const accessFilter = _.find(data.options, (option) => {
      return option.value === data.value;
    });

    const form = this.state.form;
    form.access_filter = accessFilter.value;

    this.setState({ form });
  };

  setTagOptionValuesByCategory = async (categoryStrings) => {
    const tagGroups = [];

    try {
      const tagsForAllCategories = await getTagsForCategories(categoryStrings);
      const { results } = tagsForAllCategories;

      for (let i = 0; i < results.length; i += 1) {
        const tagsByCategory = [];
        const categoryString = categoryStrings[i];
        const tags = results[i].tags;
        const emptyOption = {
          key: 0,
          text: '',
          value: ''
        };
        for (let j = 0; j < tags.length; j += 1) {
          const tagOption = {
            key: j + 1,
            text: tags[j].value,
            value: tags[j].id
          };
          tagsByCategory.push(tagOption);
        }

        tagsByCategory.push(emptyOption);

        const tagGroup = {
          category: categoryString,
          tags: tagsByCategory
        };

        tagGroups[i] = tagGroup;
      }
    } catch (error) {
      console.log('Error occured in setTagOptionValuesByCategory(): ', error);
      alert('Error: could not get tags from server!');
    }

    this.setState({
      tagsByCategoryOptions: tagGroups
    });
  };

  onTagOptionSelect = (event, { name, value }) => {
    const chosenTagByCategory = {
      category: name,
      tag: value
    };

    try {
      const currentTagsInState = this.state.chosenTagsByCategory;

      const newStateArray = [...currentTagsInState];
      const foundTagIndex = newStateArray.findIndex((tag) => {
        return tag.category === chosenTagByCategory.category;
      });

      if (foundTagIndex === -1) {
        newStateArray.push(chosenTagByCategory);
      } else {
        newStateArray.splice(foundTagIndex, 1);
        newStateArray.push(chosenTagByCategory);
      }

      this.setState({
        ...this.state,
        chosenTagsByCategory: newStateArray
      });
    } catch (error) {
      console.log(error);
    }
  };

  resetDashboardsTags = async () => {
    const newStateArray = [];
    this.setState({
      ...this.state,
      chosenTagsByCategory: newStateArray
    });
  };

  render() {
    const {
      name,
      alias,
      dashboardId,
      internalDesc,
      externalDesc,
      access_filter
    } = this.state.form;
    const {
      errorMessage,
      message,
      processing,
      selectedModels,
      models,
      tagsByCategoryOptions,
      chosenTagsByCategory
    } = this.state;
    const { dashboardToEdit } = this.props;

    return (
      <div className="manage-dashboard-container">
        {processing ? (
          <div>
            <span>
              <Loader inline className="active" />
              Processing...
            </span>
          </div>
        ) : null}
        <h3>{dashboardToEdit ? 'Edit' : 'Add'} Dashboard</h3>
        <Divider hidden />
        <div className="manage-dashboard-message-container">
          {errorMessage ? (
            <div>
              <span className="manage-dashboard-error">{errorMessage}</span>
            </div>
          ) : null}
          {message ? (
            <div>
              <span className="manage-dashboard-message">{message}</span>
            </div>
          ) : null}
        </div>
        <div>
          <div>
            <Form.Input
              placeholder="Dashboard Id"
              type="text"
              name="dashboardId"
              value={dashboardId}
              onChange={this.handleFormChange}
            />
            <Divider hidden />
            <Form.Input
              placeholder="Name"
              type="text"
              name="name"
              value={name}
              onChange={this.handleFormChange}
            />
            <Divider hidden />
            <Form.Input
              placeholder="Alias"
              type="text"
              name="alias"
              value={alias}
              onChange={this.handleFormChange}
            />
            <Divider hidden />
            <Dropdown
              placeholder="Models"
              className="manage-dashboard-models"
              search
              selection
              id="model"
              multiple
              value={selectedModels}
              options={models}
              onChange={this.onModelSelect}
            />
            <Divider hidden />
            <Dropdown
              placeholder="Access Filter"
              search
              selection
              id="access_filter"
              value={access_filter}
              options={models}
              onChange={this.onAccessFilterSelect}
            />
            <Divider hidden />
            <TextArea
              placeholder="Internal Description"
              className="manage-dashboard-description"
              name="internalDesc"
              value={internalDesc}
              onChange={this.handleFormChange}
            />
            <Divider hidden />
            <TextArea
              placeholder="External Description"
              className="manage-dashboard-description"
              name="externalDesc"
              value={externalDesc}
              onChange={this.handleFormChange}
            />
            <Divider hidden />
            <h3>Choose your Dashboard tags</h3>
            <Divider hidden />
            <Grid columns={12} centered>
              <Grid.Row>
                {tagsByCategoryOptions.map((tagGroup) => {
                  const { category: tagGroupCategory } = tagGroup;
                  const chosenTag = chosenTagsByCategory.find((tag) => {
                    const { category } = tag;
                    return category === tagGroupCategory;
                  });

                  const { tag: value } = chosenTag || {};
                  return (
                    <Grid.Column width={3}>
                      <h4>{tagGroup.category}</h4>
                      <Dropdown
                        id={tagGroup.category}
                        placeholder={tagGroup.category}
                        search
                        options={tagGroup.tags}
                        selection
                        className="tag-dropdown"
                        name={tagGroup.category}
                        value={value}
                        onChange={this.onTagOptionSelect}
                      />
                    </Grid.Column>
                  );
                })}
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <Button color="orange" onClick={this.resetDashboardsTags}>
                    Reset All Tags
                  </Button>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </div>
          <Divider hidden />
          <div>
            <Button onClick={this.goBackSearch} size="large" color="grey">
              Back
            </Button>
            <Button onClick={this.saveDashboard} size="large" color="blue">
              Save
            </Button>
          </div>
          <Divider hidden />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageDashboard);



// WEBPACK FOOTER //
// ./src/screens/LookerDashboard/ManageDashboard.js